import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const host = import.meta.env.VITE_BE_HOST;

export const privyApi = createApi({
  reducerPath: 'privyApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${host}/api`,
  }),
  endpoints: (builder) => ({
    createMockUser: builder.mutation({
      query: ({ privyId }) => ({
        url: '/privy/mock-user-created',
        method: 'POST',
        body: {
          privyId,
        },
      }),
    }),
  }),
});

export const { useCreateMockUserMutation } = privyApi;
